import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { duplicateTagValidationFilteringSchemaObject } from '../duplicateTagValidationSchema';
import { DuplicateTagVerificationListing } from './listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';

const screenCode = 'DUPLICATETAGVERIFICATION'

export function DuplicateTagVerificationFiltering(props) {

    const [title, setTitle] = useState("Duplicate Tag Verification");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [collectionPoint, setCollectioPoint] = useState();
    const [customer, setCustomer] = useState([]);
    const [deductionList,setDeductionList]=useState([]);
    const [duplicateTagData, setDuplicateTagData] = useState([]);
    const [duplicateTag, setDuplicateTag] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        customerID: '0',
        date: ''
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(duplicateTagValidationFilteringSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(getOperationEntitiesForDropdown());
    }, [duplicateTag.groupID]);

    useEffect(() => {
        trackPromise(getCollectionPointForDropDown());
    }, [duplicateTag.operationEntityID]);

    useEffect(() => {
        trackPromise(getCustomers(), handleSearch());
    }, [duplicateTag.collectionPointID]);

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTAGVERIFICATION');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITTAGVERIFICATION');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setDuplicateTag({
            ...duplicateTag,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.GetAllOperationEntityByGroupID(duplicateTag.groupID);
        setOperationEntity(opEntities);
    }

    async function getCollectionPointForDropDown() {
        const collectionPoint = await services.getCollectionPointByOperationEntityId(duplicateTag);
        setCollectioPoint(collectionPoint);
    }

    async function getCustomers() {
        let result = await services.getCustomersFromCollectionPoint(duplicateTag.collectionPointID);
        setCustomer(result);
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, duplicateTagValidationFilteringSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {
        if (e !== undefined) {
            const errorMessages = validate(schema, duplicateTag);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }
        const response = await services.getDuplicateTagData(duplicateTag);
        setDuplicateTagData(response);
    }

    async function editDuplicateTagDetail(data) {
        props.history.push({
            pathname: 'duplicateTagVerification/AddEdit',
            data: data,
            edit: true
        });
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setDuplicateTag({
            ...duplicateTag,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: '0',
            customerID: "0",
            date: ""
        });
        setDuplicateTagData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null) {
            setDuplicateTag({
                ...duplicateTag,
                customerID: "0"
            });
        }
        else {
            var nameV = "customerID";
            var valueV = data["customerID"];

            setDuplicateTag({
                ...duplicateTag,
                customerID: valueV.toString()
            });
        }
    }

    function handleChange(e) {
        const target = e.target;
        validateInputs(target);
        const value = target.value
        setDuplicateTag({
            ...duplicateTag,
            [e.target.name]: value
        });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                />
                            </div>
                            <hr />
                            <form disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={duplicateTag.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={duplicateTag.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionPointID">Collection Point*</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={duplicateTag.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md-6 pb-1">
                                        <InputLabel shrink id="customerID">Customer</InputLabel>
                                        <Autocomplete
                                            fullWidth
                                            id="customerID"
                                            options={customer}
                                            getOptionLabel={(option) => option.customerName}
                                            size="small"
                                            onChange={(event, value) => handleSearchDropdownChange(value)}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                        />
                                        {errors["customerID"] && <FormHelperText error>{errors["customerID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-6">
                                        <InputLabel shrink id="date">Date </InputLabel>
                                        <TextField
                                            fullWidth
                                            id="date"
                                            name="date"
                                            type="date"
                                            value={duplicateTag.date}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["date"] && <FormHelperText error>{errors["date"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                                <DuplicateTagVerificationListing duplicateTagData={duplicateTagData}
                                    handleClick={editDuplicateTagDetail}
                                />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}